require('./hireCardViaTView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { FormattedText, formatText, getFinalTitle, hasTranslation } = require('core/i18n').i18n;
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper');
const { isAvailableHireCreditCards } = require('utilities/cardsHelper');

// @actions
const hireCardViaTActions = require('actions/hireCardViaT');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const shippingAddressAction = require('actions/shippingAddress');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const HireCardViaTStep1 = require('components/hire/cardViaT/hireCardViaTStep1/hireCardViaTStep1');
const HireCardViaTStep2 = require('components/hire/cardViaT/hireCardViaTStep2/hireCardViaTStep2');
const HireCardViaTStep3 = require('components/hire/cardViaT/hireCardViaTStep3/hireCardViaTStep3');
const HireCardViaTStep4 = require('components/hire/cardViaT/hireCardViaTStep4/hireCardViaTStep4');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const { HireCardOpenCreditStepINEDIR } = require('components/hire/cardINEDIRDocument/hireCardOpenCreditStepINEDIR');
const HireCardViaTSuccess = require('components/hire/cardViaT/hireCardViaTSuccess/hireCardViaTSuccess');
const HireCardViaTError = require('components/hire/cardViaT/hireCardViaTError/hireCardViaTError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const {
    REDIRECT_URL,
    SECOND_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    CREDIT_CARD_TYPE_VIA_T,
    CREDIT_CARD_SUBTYPE_VIA_T,
    CREDIT_CARD_STANDARD_VIA_T,
} = require('constants/index');
const { HIRE_CARD_VIA_T } = require('constants/operationCodesAccounts');
const { WEB_INACTIVE_ACCOUNT_ENABLED, CREDIT_CARD_REVOLVING_PROCESS, LIMIT_CREDIT_CARD, ES_COUNTRY, MESSAGE_HIRE_24H, NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/hire/cardViaT/analytics/hireCardViaTAnalytics');

const cardImageIds = [
    'B.532.001.001'
];

class HireCardViaTView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getHireCardImages,
            match: { params: { redirect } },
            validateStep,
            getshippingAddressList,
            getBlockedAccounts,
            immAccounts,
            resetPrecontractualDocumentMail,
            immFlagBasedFeatures,
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        if (newCardsFF) {
            reset();
            resetBlockedAccounts();
            resetTermsAndCondsText();
            if (__CONTACT_CENTER__) resetPrecontractualMail()

        }

        getHireCardImages(cardImageIds);

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        resetPrecontractualDocumentMail();
        getshippingAddressList();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_VIA_T);
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props
        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) resetPrecontractualMail();
    }

    getProcessDetail() {
        return `${CREDIT_CARD_TYPE_VIA_T}.${CREDIT_CARD_SUBTYPE_VIA_T}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardViaT } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardViaT.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardViaT,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
            immShippingAddressList,
        } = this.props;
        const selectedAccount = immHireCardViaT.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardViaTSuccess
                    immAccount={immAccount}
                    immHireCardViaT={immHireCardViaT}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    processDetail={processDetail}
                />
            </div>
        );
    }
    buildConfirmationLabel(labels) {
        const labelElements = labels.map(item => {
            let element = <span key={item.text}><FormattedText value={item.text} /> </span>;
            let url;

            const href = item.href;
            url = hasTranslation(href) ? formatText(href) : href;

            if (url) {
                element = (
                    <OKLink
                        key={item.text}
                        id={item.id}
                        target="_blank"
                        to={url}
                        modifier="emphasize"
                        onClick={() => recordLink(window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(item.text))}
                    >
                        {element}
                    </OKLink>
                );
            }

            return element;
        });

        return labelElements;
    }
    buildINE() {
        const { getInitCardsDocuments, immHireCardViaT, cardsConfimationScrollDown, checkCheckedDocument, printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, hireCardOpenCreditprintDocument } = this.props;
        const documentINE = immHireCardViaT.get('documentINE')
        const scrollDown = immHireCardViaT.get('scrollDown')
        const agreeIneCheckbox = immHireCardViaT.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardViaT.get('checkButtonRadio')
        const printDocument = immHireCardViaT.get('printDocument')
        const documentsPrintedAndSigned = immHireCardViaT.get('cardsDocumentsPrintedAndSigned')

        return (
            <HireCardOpenCreditStepINE
                documentINE={documentINE}
                cardsConfimationScrollDown={cardsConfimationScrollDown}
                scrollDown={scrollDown}
                checkCheckedDocument={checkCheckedDocument}
                agreeIneCheckbox={agreeIneCheckbox}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                checkRadioButton={checkRadioButton}
                checkButtonRadio={checkButtonRadio}
                hireCardOpenCreditprintDocument={hireCardOpenCreditprintDocument}
                printDocument={printDocument}
                immPrinter={immPrinter}
                documentsPrintedAndSigned={documentsPrintedAndSigned}
                getInitCardsDocuments={getInitCardsDocuments}
            />
        );
    }
    buildINEDIR() {
        const { immHireCardViaT, documentRead, onAcceptAllDocument, saveDocumentList, checkRadioButtonIneDir } = this.props;
        const initialDocumentsList = immHireCardViaT.get('initialDocumentsList')
        const acceptedDocument = immHireCardViaT.get('acceptedDocument')
        const precontractualConfirmationLabel = [
            {
                text: 'hireCreditCard-textInfoIneDir'
            },
            {
                text: 'hireCreditCard-textLinkInfoIneDir',
                href: 'hireCreditCard-linkInfoIneDir'
            },

        ]
        const precontractualLabel = this.buildConfirmationLabel(precontractualConfirmationLabel)
        const allDocumentRead = immHireCardViaT.get('allDocumentRead')

        return (
            <HireCardOpenCreditStepINEDIR
                initialDocumentList={initialDocumentsList}
                onSavedocumentAcceptance={documentRead}
                acceptedDocument={acceptedDocument}
                onAcceptAllDocument={onAcceptAllDocument}
                precontractualLabel={precontractualLabel}
                allDocumentRead={allDocumentRead}
                saveDocumentList={saveDocumentList}
                checkRadioButtonIneDir={checkRadioButtonIneDir}
            />
        );
    }
    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardViaT,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardViaT,
            immHireContactData,
            immHireCreditLimit,
            immHireInformation,
            immHirePaymentMethod,
            immPdfData,
            immProfile,
            immShippingAddressList,
            requestPDFMerge,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setHireCreditLimit,
            setShippingAddress,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            toggleCreditLimitModal,
            validate,
            validateStep,
            immRevolvingPersistentData,
            onHandleChangeCheckBoxCC,
            myCardsTarjetasHire,
            hireCardViaTprintDocument,
            cardsConfimationScrollDownPolicy,
            hireCardViaTprintDocumentPolicy,
            printedAndSignedRadioChanged,
            enableButtonOffice,
            checkRadioButtonPolicy,
            immHireCreditCard,
            processEmail
        } = this.props;

        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const wizardActions = {
            cancel: this.handleCancel,
            finish: newCardsFF ? myCardsTarjetasHire : hireCardViaT,
            setVisibleStep,
            setWillCancel,
            validateStep,
        };
        const showPreLeaveModal = this.isReady();
        const documentsPrintedAndSigned = immHireCardViaT.get('cardsDocumentsPrintedAndSigned')
        let immSteps = newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode()) ? immHireCardViaT.get('newSteps') : immHireCardViaT.get('steps');
        const visibleStep = immHireCardViaT.get('visibleStep')
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });
        const sendMailParams = {
            type: CREDIT_CARD_TYPE_VIA_T,
            subType: CREDIT_CARD_SUBTYPE_VIA_T,
            standar: CREDIT_CARD_STANDARD_VIA_T
        };
        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        const gestorCrossEnabled = immFlagBasedFeatures.get('web-gc-enabled');
        let hasShippingAddress = true;
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const agreeIneCheckbox = immHireCardViaT.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardViaT.get('checkButtonRadio')
        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.VIA_T_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.VIA_T_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.VIA_T_CARD_STEP_3_VIEW]({ productName }),
            catalogue[analyticsId.VIA_T_CARD_STEP_4_VIEW]({ productName }),
        ];
        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardViaT.get('loadingFlag');
        const checkboxChecked = immHireCardViaT.get('agreeIneCheckbox')
        const newFinalButtonDisabledCC = newCardsFF && checkboxChecked
        const allDocumentRead = immHireCardViaT.get('allDocumentRead')
        const errorDir = immHireCreditCard.get('errorDir')
        const commonSteps = [
            <WizardStep
                cancelButton={true}
                position="first"
                isLoading={loadingFlag}
            >
                <WebappRender>
                    <HireCardViaTStep1
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        hireCmsKey={__CONTACT_CENTER__ ? "viat_cc" : "viat"}
                        immHireInformation={immHireInformation}
                        requestPDFMerge={requestPDFMerge}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WebappRender>
                <ContactCenterRender>
                    <HireCardViaTStep1
                        contractName="via-t"
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        hireCmsKey="viat"
                        immHireCardViaT={immHireCardViaT}
                        immHireInformation={immHireInformation}
                        immProfileFields={immProfile}
                        sendMailParams={sendMailParams}
                        requestPDFMerge={requestPDFMerge}
                        setTermsAndCondsText={setTermsAndCondsText}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </ContactCenterRender>
            </WizardStep>,
            <WizardStep
                nextButtonDisabled={immRevolvingPersistentData.get('isIframeError')}
                cancelButton={true}
                onBackClick={false}
                position="middle"
            >
                <HireCardViaTStep2
                    handleAccountChange={handleAccountChange}
                    immAccounts={immAccounts}
                    immGlobalVariables={immGlobalVariables}
                    immHireCardViaT={immHireCardViaT}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    setAllAccountsToInactive={setAllAccountsToInactive}
                    setHireCreditLimit={setHireCreditLimit}
                    toggleCreditLimitModal={toggleCreditLimitModal}
                    validate={validate}
                    newCardsFF={newCardsFF}
                />
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isShippingAddressButtonDisabled}
            >
                <HireCardViaTStep3
                    immHireContactData={immHireContactData}
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                />
            </WizardStep>,
            <WizardStep
                addLoadingBehaviour={true}
                cancelButton={true}
                immFinalButton={'hireCardViaT-hire'}
                isLoading={immHireCardViaT.get('isFetching')}
                onBackClick={false}
                position="last"
                officeSignature={newCardsFF && isPrintOfficeMode()}
                finalButtonDisabled={newCardsFF ? (newFinalButtonDisabledCC ? false : true) : null}
            >
                <HireCardViaTStep4
                    contractName="via-t"
                    immHireCardViaT={immHireCardViaT}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immPdfData={immPdfData}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    operativeName={__CONTACT_CENTER__ ? "operatives-cardHire_viaT" : undefined}
                    sendMailParams={sendMailParams}
                    sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                    setTermsAndCondsText={setTermsAndCondsText}
                    showIneAndRevolving={showIneAndRevolving}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    hireCardViaTprintDocument={hireCardViaTprintDocument}
                    cardsConfimationScrollDownPolicy={cardsConfimationScrollDownPolicy}
                    hireCardViaTprintDocumentPolicy={hireCardViaTprintDocumentPolicy}
                    printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                    enableButtonOffice={enableButtonOffice}
                    checkRadioButtonPolicy={checkRadioButtonPolicy}
                    documentsPrintedAndSigned={documentsPrintedAndSigned}
                    processEmail={processEmail}
                />
            </WizardStep>
        ];
        const newSteps = newCardsFF && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
            ...commonSteps.slice(0, 3),
            __CONTACT_CENTER__ && !isPrintOfficeMode() || errorDir ?
                <WizardStep
                    cancelButton={true}
                    onBackClick={false}
                    position="middle"
                    nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
                >
                    {this.buildINE()}
                </WizardStep> :
                <WizardStep
                    cancelButton={true}
                    onBackClick={false}
                    position="middle"
                    nextButtonDisabled={allDocumentRead}
                >
                    {this.buildINEDIR()}
                </WizardStep>,
            ...commonSteps.slice(3)
        ] : commonSteps;
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHireCardViaT.get('visibleStep') - 1]}
                        visibleStep={immHireCardViaT.get('visibleStep')}
                        wizardClass="hire-card-via-t__wizard"
                        isTaggingSecondVersion
                    >
                        {newSteps}
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                hasShippingAddress={hasShippingAddress}
                                immAccounts={immAccounts}
                                immAddress={immShippingAddress}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCreditLimit={immHireCreditLimit}
                                immShippingAddressList={immShippingAddressList}
                                immHirePaymentMethod={immHirePaymentMethod}
                                immProfile={immProfile}
                                isViaT={true}
                                selectedAccount={immSteps.getIn([SECOND_STEP, 'accountId'])}
                                creditType={'viat'}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            immHireCardViaT,
            immAccounts,
            immCards,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const pageTitle = getFinalTitle('hireCardViaT-pageTitle');
        let hasAvailableAccounts = true;
        if (__CONTACT_CENTER__) {
            hasAvailableAccounts = ownerFromAccount(immAccounts);
        }
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardViaT-breadcrumb")
            }
        ];

        const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
        const isSecondStep = immHireCardViaT.get('visibleStep') == WIZARD_SECOND_STEP;
        const isNerudaUser = immProfile.get('isNerudaUser');
        const creditCardsLimitExceed = immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) && !isNerudaUser && !hasAvailableCreditCards && isSecondStep;
        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardViaT.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;
        if (immHireCardViaT.get('error')
            || (__CONTACT_CENTER__ && !hasAvailableAccounts)
            || creditCardsLimitExceed) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardViaTError
                        immHireCardViaT={immHireCardViaT}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardViaTError
                        immHireCardViaT={immHireCardViaT}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        }
        else if (immHireCardViaT.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-via-t">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardViaTView.propTypes = {
    getHireCardImages: PropTypes.func.isRequired,
    getshippingAddressList: PropTypes.func,
    getBlockedAccounts: PropTypes.func,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardViaT: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardViaT: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    immPdfData: PropTypes.object.isRequired,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immRevolvingPersistentData: PropTypes.object,
};

module.exports.constructor = HireCardViaTView;
module.exports.HireCardViaTView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardViaT: state.hireCardViaT,
        immHireCreditCard: state.hireCreditCard,
        immHireContactData: state.hireContactData,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immPdfData: state.precontractualsMergePdfs,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
        immRevolvingPersistentData: state.revolvingPersistentData,
        immPrinter: state.printer,
    }),
    {
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        handleAccountChange: hireCardViaTActions.setAccount,
        handleAgreementCheckboxChange: hireCardViaTActions.setAgreementCheckbox,
        hireCardViaT: hireCardViaTActions.hireCardViaT,
        onHandleChangeCheckBoxCC: hireCardViaTActions.onHandleChangeCheckBoxCC,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        reset: hireCardViaTActions.reset,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setAllAccountsToInactive: hireCardViaTActions.setAllAccountsToInactive,
        setHireCreditLimit: hireCreditLimitActions.setHireCreditLimit,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardViaTActions.setVisibleStep,
        setWillCancel: hireCardViaTActions.setWillCancel,
        toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
        validate: hireCardViaTActions.validate,
        validateStep: hireCardViaTActions.validateStep,
        cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
        getInitCardsDocuments: hireCardCreditINEActions.getInitCardsDocuments,
        cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
        checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
        printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
        enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
        checkRadioButton: hireCardViaTActions.checkRadioButton,
        checkRadioButtonPolicy: hireCardViaTActions.checkRadioButtonPolicy,
        hireCardOpenCreditprintDocument: hireCardViaTActions.printDocument,
        hireCardOpenCreditprintDocumentPolicy: hireCardViaTActions.printDocumentPolicy,
        hireCardViaTprintDocument: hireCardViaTActions.printDocument,
        hireCardViaTprintDocumentPolicy: hireCardViaTActions.printDocumentPolicy,
        myCardsTarjetasHire: hireCardViaTActions.myCardsTarjetasHire,
        processEmail: hireCardViaTActions.processEmail,
        setCardViaTLimit: hireCardViaTActions.setCardViaTLimit,
        documentRead: hireCardViaTActions.documentRead,
        onAcceptAllDocument: hireCardViaTActions.onAcceptAllDocument,
        saveDocumentList: hireCardViaTActions.saveDocumentList,
        checkRadioButtonIneDir: hireCardViaTActions.checkRadioButtonIneDir,

    }
)(withRouter(HireCardViaTView));
